import { render, staticRenderFns } from "./OrderVpnResult.vue?vue&type=template&id=5930521a&scoped=true&"
import script from "./OrderVpnResult.vue?vue&type=script&lang=js&"
export * from "./OrderVpnResult.vue?vue&type=script&lang=js&"
import style0 from "./OrderVpnResult.vue?vue&type=style&index=0&id=5930521a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5930521a",
  null
  
)

export default component.exports